import React from "react";
import "./style.css";
import Footer from "../../Elements/Footer/index";
import Navbar1 from "../../Elements/Navbar1/index.js";
import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";

const ContactPage = () => {
  return (
    <>
      <Navbar1 />
      <div className="contact-container">
        <h1 className="contact-header">
          Contact Us for a Personalized Demo or Custom Quote
        </h1>

        <div className="cards">
          <div className="contact-info-card">
            <h2>Get in Touch</h2>
            <div className="contact-item">
              <div className="icon-wrapper">
                <MdEmail />
              </div>
              <div className="text-wrapper">
                <h3>Email Us</h3>
                <a href="mailto:contact@i3partners.net">
                  contact@i3partners.net
                </a>
              </div>
            </div>

            <div className="contact-item">
              <div className="icon-wrapper">
                <MdPhone />
              </div>
              <div className="text-wrapper">
                <h3>Call Us</h3>
                <a href="tel:+41-786678979">+41-786678979</a>
              </div>
            </div>
          </div>

          <div className="contact-info-card">
            <h2>Our Address</h2>
            <div className="contact-item">
              <div className="icon-wrapper">
                <MdLocationOn />
              </div>
              <div className="text-wrapper">
                <h3>Registered Address</h3>
                <p>
                  i3 Partners GmbH, 
                  <br/>
                  In den Steinreben 4d, 
                  <br/>
                  Reinach BL 4153 Switzerland
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
